import { ScrollText, Gem, Sparkles, ShieldCheck } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const BENEFITS = [
  {
    icon: ScrollText,
    title: "Authentic",
    text: "Inspired by traditional Indian dairy practices.",
  },
  {
    icon: Gem,
    title: "Premium",
    text: "Carefully selected and presented to a premium standard.",
  },
  {
    icon: Sparkles,
    title: "Rich & Aromatic",
    text: "A naturally rich flavour and aroma suited to everyday Indian cooking.",
  },
  {
    icon: ShieldCheck,
    title: "Trusted",
    text: "A brand built around transparency, quality and customer satisfaction.",
  },
];

export default function Benefits() {
  return (
    <section id="why-mahira" data-testid="benefits-section" className="bg-ivory py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHeading eyebrow="The MAHIRA Standard" title="Why Customers Choose MAHIRA" />
        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {BENEFITS.map((b, i) => (
            <Reveal key={b.title} delay={i * 0.08}>
              <div
                data-testid={`benefit-card-${b.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group h-full rounded-3xl border border-forest/10 bg-white/60 p-8 transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 hover:border-gold/40 hover:shadow-[0_30px_60px_-25px_rgba(26,54,38,0.25)]"
              >
                <div className="flex items-center justify-between">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-gold-light/50 text-forest transition-colors duration-500 group-hover:bg-gold group-hover:text-forest">
                    <b.icon className="h-5 w-5" />
                  </span>
                  <span className="font-heading text-4xl text-forest/10 transition-colors duration-500 group-hover:text-gold/40">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="mt-8 font-heading text-2xl text-forest">{b.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-charcoal/65">{b.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
